import React from "react";

import { quotes as quotesApi } from "@/api";
import QuoteCreateForm from "@/components/QuoteCreateForm";
import { formatApiError } from "@/lib/api";

/**
 * Enveloppe modale du formulaire de devis commun.
 *
 * Le Pipeline conserve son workflow historique : un devis créé depuis
 * l'action directe du pipeline est immédiatement soumis à validation.
 * Toute la saisie métier reste centralisée dans QuoteCreateForm.
 */
export default function DirectQuoteModal({
  open,
  lockedProspect = null,
  onClose,
  onCreated,
}) {
  if (!open) return null;

  const handleCreated = async (quote) => {
    if (!quote?.id) {
      throw new Error("Identifiant du devis créé introuvable.");
    }

    try {
      await quotesApi.submit(quote.id);
    } catch (error) {
      throw new Error(
        formatApiError(error.response?.data?.detail) ||
          "Le devis a été créé, mais sa soumission à validation a échoué."
      );
    }

    await onCreated?.({
      quote,
      submitted: true,
    });

    onClose?.();
  };

  return (
    <div
      className="acta-modal-overlay fixed inset-0 z-[120] flex items-center justify-center p-3 sm:p-4"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose?.();
        }
      }}
    >
      <section
        role="dialog"
        aria-modal="true"
        aria-label="Nouveau devis"
        className="acta-modal-surface acta-modal-scroll max-h-[calc(100dvh-2rem)] w-full max-w-5xl rounded-3xl bg-[var(--do-bg-solid)] p-0 shadow-2xl sm:max-h-[calc(100dvh-3rem)]"
        data-testid="direct-quote-modal"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <QuoteCreateForm
          lockedProspect={lockedProspect}
          onCancel={onClose}
          onCreated={handleCreated}
        />
      </section>
    </div>
  );
}
